import React, {useEffect, useState} from "react";
import {Alert, Backdrop, CircularProgress, Container, Pagination, styled} from "@mui/material";
import {getQueryParams, handleHttpResponse} from "../utils/http-helpers";
import {ApiUrl} from "../utils/portal-urls";
import AuditLogsSearchPanel from "./AuditLogsSearchPanel";
import ShowSnackbar from "../utils/ShowSnackbar";
import AuditLogsAsList from "./AuditLogsAsList";

const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
}))
export default function AuditLogsHome (props) {

    const getParameters = getQueryParams();

    const [tableListLoading, setTableListLoading] = useState(false);
    const [hisps, setHisps] = useState(null);
    const [types, setTypes] = useState(null);
    const [refresh, setRefresh] = useState("");
    const [page, setPage] = useState(getParameters.page ? parseInt(getParameters.page) : 0);
    const [pageResult, setPageResult] = useState(null);
    const [query, setQuery] = useState("");
    const [queryCount, setQueryCount] = useState(0);
    const [currentViewingQuery, setCurrentViewingQuery] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);


    useEffect(() => {
        console.log("page changed or refresh, useEffect fetch: ", query, page);
        if (query !== currentViewingQuery && queryCount > 0 && page > 0) {
            setPage(0);
        } else {
            fetchPage(query, page);
        }
    }, [query, page, refresh])


    const fetchPage = (query, page) => {
        setTableListLoading(true);
        const url = ApiUrl.AuditLogs.query.getPath(query, page);
        console.log("GET Audit logs from: " + url);
        fetch(url)
            .then(handleHttpResponse)
            .catch( err => {
                setTableListLoading(false);
                if (err) {
                    console.error(err);
                    setSnackbarOpen(true);
                }
            })
            .then( res => {
                setTableListLoading(false);
                if (res) {
                    setCurrentViewingQuery(query);
                    setPageResult(res);

                    const hispsArray = [];
                    const typesArray = [];
                    res.content.map( d => {
                        if (d.hisp !== null && d.hisp !== "") {
                            if (!hispsArray.includes(d.hisp)) {
                                hispsArray.push(d.hisp);
                            }
                        }
                        if (!typesArray.includes(d.type)) {
                            typesArray.push(d.type);
                        }
                    })
                    setHisps(hispsArray);
                    setTypes(typesArray);
                }
            })
    }

    return (
        <StyledContainer >
            <h3 className="title">
                Audit Logs
            </h3>
            <AuditLogsSearchPanel  onRefresh={(r) => setRefresh(r)} onQueryStringChanged={(q) => setQuery(q)} types={types} setPage={(p) => setPage(p)}/>

            <hr/>
            <div className="type-list-wrap">
                {pageResult &&
                    <Alert severity='info' icon={false}>
                        Found {pageResult.totalElements} record(s).&nbsp;
                        {pageResult.totalPages > 1 && `Showing page ${pageResult.pageable.pageNumber + 1} (${pageResult.pageable.offset + 1} ... ${pageResult.pageable.offset + pageResult.pageable.pageSize})`}
                    </Alert>}
                {pageResult && pageResult.content && pageResult.content.length > 0 &&
                    <div>
                        <AuditLogsAsList auditLogs={pageResult.content} page={page} setPage={(c) => setPage(c)}/>
                        <br/>
                        {pageResult.totalPages > 1 &&
                            <Pagination page={page + 1} count={pageResult.totalPages} variant="outlined" color="primary" onChange={(e, newPage) => setPage(newPage - 1)}/>}
                    </div>
                }

            </div>

            <ShowSnackbar open={snackbarOpen} close={(c) => setSnackbarOpen(c)} msg={{msg: "Failed to get contribution records", msgLv: "error"}} />


            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}}
                      open={tableListLoading}>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </StyledContainer>
    )
}